




import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import echarts from "echarts";
import debounce from "lodash/debounce";

require("echarts/theme/dark");
require("echarts/theme/macarons");
require("echarts/theme/shine");
require("echarts/theme/roma");
require("echarts/theme/vintage");
require("echarts/theme/infographic");

@Component
export default class ReportChart extends Vue {
  @Prop({ type: Object, required: true })
  chartOption!: any;

  switchSvg = "path://M571.392 839.68l47.104 47.104c8.192 8.192 8.192 20.48 0 28.672-8.192 8.192-20.48 8.192-28.672 0l-96.256-96.256 96.256-96.256c8.192-8.192 20.48-8.192 28.672 0s8.192 20.48 0 28.672l-47.104 47.104h77.824c102.4 0 184.32-81.92 184.32-184.32v-122.88c0-12.288 8.192-20.48 20.48-20.48s20.48 8.192 20.48 20.48v122.88c0 124.928-100.352 225.28-225.28 225.28h-77.824z m-77.824-614.4h-94.208c-102.4 0-184.32 81.92-184.32 184.32v122.88c0 12.288-8.192 20.48-20.48 20.48s-20.48-8.192-20.48-20.48v-122.88c0-124.928 100.352-225.28 225.28-225.28h94.208l-47.104-47.104c-8.192-8.192-8.192-20.48 0-28.672s20.48-8.192 28.672 0l96.256 96.256-96.256 96.256c-8.192 8.192-20.48 8.192-28.672 0s-8.192-20.48 0-28.672l47.104-47.104z m-227.328 503.808l-120.832-120.832c-8.192-8.192-20.48-8.192-28.672 0-8.192 8.192-8.192 20.48 0 28.672l131.072 131.072v133.12c0 12.288 8.192 20.48 20.48 20.48s20.48-8.192 20.48-20.48v-135.168-2.048l129.024-129.024c8.192-8.192 8.192-20.48 0-28.672-8.192-8.192-20.48-8.192-28.672 0l-122.88 122.88z m512-512l-100.352-100.352c-8.192-8.192-20.48-8.192-28.672 0-8.192 8.192-8.192 20.48 0 28.672l100.352 100.352-100.352 100.352c-8.192 8.192-8.192 20.48 0 28.672 8.192 8.192 20.48 8.192 28.672 0l100.352-100.352 100.352 100.352c8.192 8.192 20.48 8.192 28.672 0 8.192-8.192 8.192-20.48 0-28.672l-100.352-100.352 100.352-100.352c8.192-8.192 8.192-20.48 0-28.672-8.192-8.192-20.48-8.192-28.672 0l-100.352 100.352z";

  created() {
    this.onResizeChart = debounce(this.onResizeChart.bind(this), 500);
  }

  @Watch("chartOption")
  onDataChange() {
    const chart = echarts.init(this.$refs.chart as HTMLCanvasElement, "shine");
    chart.clear();
    const newOption = this.chartOption;
    // delete newOption.title;
    const me = this;
    if (this.chartOption.enableSwitchXY) {
      this.chartOption.toolbox.feature.mySwitchXY = {
        show: true,
        title: "交换XY轴",
        icon: this.switchSvg,
        onclick: function (params: any) {
          me.onSwitchXY();
        }
      };
    }

    chart.setOption(newOption);
    if (this.chartOption.events) {
      for (let i = 0; i < this.chartOption.events.length; i++) {
        const event = this.chartOption.events[i];
        chart.on(event.name, function (params: any) {
          event.handler(chart, params);
        });
      }
    }

    chart.resize();
  }

  onSwitchXY() {
    this.$emit("switchXY");
  }

  onResizeChart() {
    const chartDom = this.$refs.chart as HTMLCanvasElement;
    if (!chartDom) {
      return;
    }
    const chart = echarts.getInstanceByDom(chartDom);
    if (chart) {
      chart.resize();
      if (this.chartOption.events) {
        for (let i = 0; i < this.chartOption.events.length; i++) {
          const event = this.chartOption.events[i];
          if (event.name === "resized") {
            event.handler(chart);
          }
        }
      }
    }
  }

  mounted() {
    window.addEventListener("resize", this.onResizeChart);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.onResizeChart);
  }
}
